import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({ data }) => {
    const rows = [
        { label: 'Available Quantity', value: data.availableStock.toFixed(2) },
    ];

    return <PPMobileCardView title={data.materialName} rows={rows} />;
};

export default Mobile;
